<!-- <div class="relative z-50">
  <app-top-nav-bar></app-top-nav-bar>
</div> -->
<div *ngIf="gazeti && page" class="sticky top-0 z-40 bg-white border-b border-gray-200 shadow-sm">
  <div class="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between">
    
    <button 
      (click)="goBack()" 
      class="flex items-center gap-2 text-gray-600 hover:text-primary-600 font-medium transition-colors group">
      <mat-icon class="transition-transform group-hover:-translate-x-1">arrow_back</mat-icon>
      <span class="hidden sm:inline">Back to Collection</span>
    </button>

    <div class="flex items-center bg-primary-50 rounded-full px-4 py-1.5 border border-gray-200">
      <button 
        (click)="prevPage()" 
        [disabled]="!page.hasPreviousPage || loadingPage"
        class="p-1 disabled:opacity-30 text-gray-500 hover:text-primary-600">
        <mat-icon>chevron_left</mat-icon>
      </button>

      <div class="px-4 border-x border-gray-200 mx-2 flex flex-col items-center">
        <span class="text-xs text-gray-400 font-bold uppercase tracking-tighter">Page</span>
        <span class="text-sm font-black text-gray-900">{{ page.pageNumber }} / {{ gazeti.totalPages }}</span>
      </div>

      <button 
        (click)="nextPage()" 
        [disabled]="!page.hasNextPage || loadingPage"
        class="p-1 disabled:opacity-30 text-gray-500 hover:text-primary-600">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>

    <div class="hidden lg:flex flex-col items-end">
      <span class="text-[10px] uppercase font-bold text-primary-600 tracking-widest">Reading Now</span>
      <span class="text-sm font-bold text-gray-800 truncate max-w-[200px]">{{ gazeti.title }}</span>
    </div>
  </div>
</div>

<div class="h-screen overflow-y-auto flex flex-col bg-gray-100">
  <!-- Loader -->
  <div
    *ngIf="loading"
    class="flex-1 flex flex-col items-center justify-center gap-4"
  >
    <div
      class="animate-spin rounded-full h-10 w-10 border-4 border-gray-300 border-t-primary-600"
    ></div>
    <p class="text-lg text-gray-700 font-medium">Loading...</p>
  </div>

  <!-- Error -->
  <div *ngIf="error" class="flex-1 flex items-center justify-center px-8">
    <p class="text-2xl text-red-600 text-center font-bold">{{ error }}</p>
  </div>

  <!-- Page not found -->
  <div
    *ngIf="!loading && !error && gazeti && !page"
    class="flex-1 flex items-center justify-center px-8"
  >
    <div class="text-center">
      <mat-icon class="text-gray-400 mx-auto mb-6 text-[80px]"
        >article</mat-icon
      >
      <p class="text-2xl font-medium text-gray-700 mb-2">Page not found</p>
      <p class="text-lg text-gray-500">
        Gazette not found. Please select another gazette.
      </p>
    </div>
  </div>

  <!-- No Gazeti at all -->
  <div
    *ngIf="!loading && !error && !gazeti"
    class="flex-1 flex items-center justify-center px-8"
  >
    <p class="text-2xl text-gray-600 text-center font-medium">
      Gazette not found. Please select another gazette.
    </p>
  </div>

  <!-- Main Content -->
  <div
    *ngIf="gazeti && page && !loading && !error"
      [@pageSlide]="pageAnimationState"
    class="flex-1 overflow-y-auto py-8 px-4"
  >
    <div class="max-w-4xl lg:max-w-6xl mx-auto">
      <article
        class="bg-white rounded-sm shadow-sm overflow-hidden flex flex-col"
      >
        <!-- Header -->
        <header
          class="bg-gray-50 border-b-2 border-black px-8 py-10 text-center"
        >
          <h1
            class="text-4xl sm:text-5xl md:text-6xl font-black text-gray-900 leading-tight tracking-tight"
          >
            {{ gazeti.title }}
          </h1>
          <div
            class="mt-8 flex flex-col sm:flex-row justify-between items-center text-lg font-bold text-gray-800 border-t-2 border-black pt-6"
          >
            <span>Publication Number: #{{ gazeti.publicationNumber }}</span>
            <span
              >Date: {{ gazeti.publicationDate | date : "dd MMMM yyyy" }}</span
            >
          </div>
        </header>

        <!-- Cover Image -->
        <!-- Cover Image -->
        <!-- <div class="px-8 py-12 overflow-hidden  bg-white">
  <img
    [src]="getImageUrl(gazeti.bundleFile?.mediaUrl || gazeti.thumbnail)"
    alt="Cover of {{ gazeti.title }}"
    class="w-full h-66 md:h-[500px] object-center rounded-xl"
    (error)="onImageError($event)"
  />
</div> -->

        <!-- Articles -->
        <section
          class="px-6 sm:px-10 lg:px-20 py-12 text-gray-800 leading-relaxed text-lg flex-1"
        >
          <div class="space-y-24">
            <div
              *ngFor="let item of page.contentItems"
              class="border-b-2 border-gray-300 pb-24 last:border-0 last:pb-0"
            >
              <!-- Title & Subtitle -->
              <h2
                class="text-3xl sm:text-4xl font-bold text-gray-900 mb-6 leading-tight"
              >
                {{ item.title }}
              </h2>
              <p
                *ngIf="item.subtitle"
                class="text-xl sm:text-2xl italic text-gray-700 mb-4"
              >
                {{ item.subtitle }}
              </p>

              <!-- Author -->
              <p
                *ngIf="item.author"
                class="text-base text-gray-600 font-medium mb-2"
              >
                Author: {{ item.author }}
              </p>

              <div
                *ngIf="item.filePath"
                class="mt-4 mb-6 overflow-hidden rounded-sm shadow-md border border-gray-300"
              >
                <img
                  [src]="getImageUrl(item.filePath)"
                  alt="File for {{ item.title }}"
                  class="w-full h-64 object-cover"
                  (error)="onImageError($event)"
                />
              </div>

              <!-- Content -->
              <div
                class="prose prose-lg max-w-none break-words hyphens-auto text-justify"
                [innerHTML]="item.content"
              ></div>

              <!-- Media -->
              <div *ngIf="item.mediaList?.length" class="mt-16 space-y-12">
                <div *ngFor="let media of item.mediaList" class="text-center">
                  <img
                    [src]="getImageUrl(media.mediaUrl)"
                    [alt]="media.caption || item.title"
                    class="max-w-full lg:max-w-5xl mx-auto rounded-xl shadow-xl border-4 border-gray-300"
                    (error)="onImageError($event)"
                  />
                  <p
                    *ngIf="media.caption"
                    class="mt-6 text-base italic text-gray-600 max-w-4xl mx-auto"
                  >
                    {{ media.caption }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- Footer -->
        <footer class="bg-white border-t-2 border-black px-8 py-8">
          <div class="flex items-center justify-between">
            <button
              (click)="prevPage()"
              [disabled]="!page.hasPreviousPage"
              class="disabled:opacity-40 p-5 rounded-full hover:bg-gray-100 transition"
            >
              <mat-icon class="text-gray-600 text-3xl">chevron_left</mat-icon>
            </button>

            <p class="text-lg font-normal text-gray-800">
              Page
              <span class="text-gray-600 text-lg">{{ page.pageNumber }}</span>
              <span class="text-gray-500 text-lg">
                / {{ gazeti.totalPages }}</span
              >
            </p>

            <button
              (click)="nextPage()"
              [disabled]="!page.hasNextPage"
              class="disabled:opacity-40 p-5 rounded-full hover:bg-gray-100 transition"
            >
              <mat-icon class="text-gray-600 text-3xl">chevron_right</mat-icon>
            </button>
          </div>
        </footer>
      </article>
    </div>
  </div>
</div>
